// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { ContactRole } from './contact-role';
import { Dealer } from './dealer';
import { Vendor } from './vendor';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class Contact extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  get displayRole() {
    return (this.roleId === ContactRole.Roles.Other ? this.otherRole : this.role?.name) ?? '';
  }
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  created!: Date;
  createdBy?: string;
  dealerId?: number;
  deleted?: Date;
  deletedBy?: string;
  email?: string;
  name?: string;
  notes?: string;
  otherRole?: string;
  phone?: string;
  roleId!: number;
  vendorId?: number;
  dealer!: Dealer;
  role!: ContactRole;
  vendor!: Vendor;
}

